import { api } from "@/lib/api";
import PlatzreifeBoard from "@/components/platzreife/PlatzreifeBoard";

const Platzreife = ({ canEdit = true, canEditDetails = false }) => (
  <div data-testid="admin-platzreife-page">
    <PlatzreifeBoard client={api} base="/admin" kicker="// PLATZREIFE · SYNCHRON MIT PRO-PORTAL"
      canEdit={canEdit} canEditDetails={canEditDetails} />
  </div>
);

export default Platzreife;
